import React from 'react'
import { createPortal } from 'react-dom'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import type { RouteDef } from '@ztechapps/common.contract'
import { getWindow } from '@ztechapps/common.utils'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { AttachConversation } from './AttachConversation'

export type ConversationActionsProps = { conversationId?: string }

// The document-side conversation actions behind one icon button, so they take the width of one control in
// the composer toolbar: View conversation (when linked) and Replace / Attach conversation.
export const ConversationActions = ({ conversationId }: ConversationActionsProps) => {
  const conversationItemRoute = useInject<RouteDef>(WebuiIocKey.routes.conversationItem)

  // The menu portals to the body, like ComposerModeToggle's: TinyMCE's `.tox` reset strips the background and
  // border from every descendant of the editor header, so an inline menu would render unstyled. A ternary, not a
  // ShowIf: the hidden branch must stay unbuilt until the body exists.
  const portalTarget = getWindow()?.document.body

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="link" aria-label="Conversation actions">
        <Icon name="comments" aria-hidden="true" />
      </Dropdown.Toggle>
      {portalTarget
        ? createPortal(
            <Dropdown.Menu renderOnMount>
              <ShowIf condition={!!conversationId}>
                <Dropdown.Item as={Link} to={conversationItemRoute.altPath({ _id: conversationId ?? '' })}>
                  <Icon name="external-link" aria-hidden="true" /> View conversation
                </Dropdown.Item>
              </ShowIf>
              <AttachConversation conversationId={conversationId} />
            </Dropdown.Menu>,
            portalTarget
          )
        : null}
    </Dropdown>
  )
}
